module.exports = __webpack_public_path__ + "static/scenes-solutions-1-d6bfd4a20058d3eb12ab17268dc0d3f6.svg";